module.exports = __webpack_public_path__ + "static/visibuy-ab0ca5ce418e81591f640cee61757b28.mp4";